<template>
  <div :class="['price-list-item-fi', `price-list-item-fi--${theme}`]">
    <div
      v-if="!isEditMode"
      class="price-list-item-fi__heading"
    >
      {{ fields.heading?.value }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-else
      class="price-list-item-fi__heading"
      v-html="fields.heading?.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
    <div class="price-list-item-fi__features">
      <price-list-item-feature-fi
        v-for="feature in features"
        :key="feature.id"
        :feature="feature"
        :light="theme === 'highlighted'"
      />
    </div>
    <div
      v-if="!isEditMode && fields.footer?.value"
      class="price-list-item-fi__footer"
    >
      {{ fields.footer?.value }}
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      v-if="isEditMode"
      class="price-list-item-fi__footer"
      v-html="fields.footer?.editable"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { CheckboxField, SingleLineTextField } from '@/sitecoreFieldTypes';

import PriceListItemFeatureFi, {
  type PriceListItemFeature,
} from './price-list-item-feature-fi/PriceListItemFeatureFi.vue';

defineOptions({ name: 'PriceListFi' });

interface PriceListItemFields {
  heading?: SingleLineTextField;
  footer?: SingleLineTextField;
  theme?: SingleLineTextField;
  /** Dynamic `featureText{n}` / `featureCheck{n}` fields. */
  [fieldName: string]: SingleLineTextField | CheckboxField | undefined;
}

const props = withDefaults(
  defineProps<{
    fields?: PriceListItemFields;
  }>(),
  {
    fields: () => ({}),
  },
);

const features = computed<PriceListItemFeature[]>(() =>
  Object.entries(props.fields)
    .filter(([textFieldName]) => textFieldName.startsWith('featureText'))
    .map(([textFieldName, textField]: [string, any]) => {
      const index = (textFieldName.match(/(\d+)/g) || [])[0];
      const checkField = props.fields[`featureCheck${index}`];
      return {
        id: index,
        text: textField.value,
        checked: checkField ? Boolean(checkField.value) : false,
        editable: textField.editable,
      };
    }),
);

// This can be "default", "highlighted" or "dark".
const theme = computed(() => (props.fields.theme ? props.fields.theme.value : 'default'));
</script>

<style scoped src="./price-list-item-fi" />
